// packages block
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import React, { useEffect, useState, useRef } from "react";
import { Popper, Paper, Grow, ClickAwayListener, MenuItem, MenuList, Avatar, Box, Typography, Button } from "@material-ui/core";
// common block
import "./style.css";
import { DetailTabs } from "./components/detailTabs";
import { BackButton } from "../../components/backButton";
import { AddBankDialog } from "../../components/dialogs";
import { useStyles } from "../../components/managementTable/styles";
// constants, theme, utils and api block
import { setAlert } from "../../redux/reducers/alert";
import { PrimaryBackgroundColor } from "../../styles/colors";
import { deleteBank, getBankById, setPriorityAccount } from "../../api/banks";
import { BLUE_EIGHT, WHITE } from "../../theme";
import { FormButton } from "../../components/form";

export const BankDetail = (props) => {
  const [isEditText, setIsEditText] = useState("");
  const [open, setOpen] = useState(false);
  const [isAddBankDialogVisible, setIsAddBankDialogVisible] =
    useState(false);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [banks, setBanks] = useState([]);
  const anchorRef = useRef(null);
  const [bankValue, setBankValue] = useState('');
  const [bankName, setBankName] = useState('');
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory()
  const { t } = useTranslation();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const accountId =
    props && props.match && props.match.params && props.match.params.accountId;
  const userData =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.banks;

  const { token } = useSelector((state) => state.user);

  const bankDelete = async () => {
    try {
      await deleteBank(accountId, token);
      showSuccessAlert(t("text_bank_deleted_successfully"));
      history.push("/accounts")
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_bank_please_try_again")
      );
    }
  };

  const editBankDetail = () => {
    setIsAddBankDialogVisible(true);
  };

  const closeAddUserDialog = () => {
    setIsAddBankDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const fetchBank = async () => {
    try {
      const response = await getBankById(accountId, token);
      if (!response.status) {
        showErrorAlert(response?.message || t("text_error_in_fetching_bank_detail"));
        return;
      }
      setBankValue(response?.account?.banksLeanId)
      setBankName(response?.account?.banksLean?.name)
      setIsEditedItem(response?.account);
      setBanks(response?.account)
    } catch (err) {
      showErrorAlert(err.message || t("text_error_in_fetching_bank_detail"));
    }
  };

  const editCallback = (text) => {
    setIsEditText(text);
  };

  const handlePriority = async () => {
    try {
      await setPriorityAccount(accountId, token)
      showSuccessAlert("Successfuly");
      history.push("/accounts")
    } catch (err) {
      showErrorAlert(
        err.message || "Something went wrong"
      );
    }

  }

  useEffect(() => {
    if (accountId) {
      fetchBank();
    }
  }, [accountId]);

  return (
    <>
      <Typography variant="h4" style={{ color: "black", fontWeight: "bold", flex: 1, paddingBottom: "10px", marginBottom: 20 }}>
        {"View Bank Details"}
      </Typography>

      <div className="bank-management-page bank-details-row">
        <div className="bank-detail-container bank-details-col1" >
          <div style={{ padding: '20px 20px 0px 20px', display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <BackButton />

            <Box display="flex" flexDirection="row" maxWidth="16vw" width="100%" justifyContent="flex-end" alignItems="center">
              <FormButton
                height={40}
                width={"13vw"}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                borderColor={BLUE_EIGHT}
                titleColor={BLUE_EIGHT}
                hoverTitleColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                backgroundColor={WHITE}
                hoverBackgroundColor={BLUE_EIGHT}
                title={"Make default account"}
                style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 }}
                onClickHandler={handlePriority}
              />

              <div
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                role="presentation"
                className={classes.actionButton}
              >
                <MoreHorizIcon />
              </div>
            </Box>

            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: "1" }}>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        <MenuItem style={{ color: "black", fontWeight: "bold", fontSize: "12px" }} onClick={editBankDetail}>{t("text_edit_bank")}</MenuItem>
                        <MenuItem style={{ color: "black", fontWeight: "bold", fontSize: "12px" }} onClick={bankDelete}>{t("text_delete_bank")}</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

          <div
            style={{
              padding: "20px 60px",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          />
          <DetailTabs bank={banks} />
        </div>

        {
          isAddBankDialogVisible && (
            <AddBankDialog
              bankValue={bankValue}
              bankName={bankName}
              title={t("text_edit_bank")}
              handleClose={closeAddUserDialog}
              open={isAddBankDialogVisible}
              editCallback={editCallback}
              successCallback={
                () => history.push("/accounts")
              }
              isEditedItem={isEditedItem}
              showCircularProgressBar={true}
            />
          )
        }
      </div>
    </>
  );
};
